import { ChakraFlex, Tag, TagColor, Text } from '@equip.health/ui';
import { AriaAttributes } from 'react';

interface TagListOrNotSetProps {
  id: string;
  tags?: string[];
}

const TagListOrNotSet = ({
  id,
  tags,
  'aria-labelledby': ariaLabelledBy,
}: TagListOrNotSetProps & Pick<AriaAttributes, 'aria-labelledby'>) => {
  const tagListId = `${id}__tag-list`;
  if (!tags || tags.length === 0) {
    return <Text color="neutral.tertiary">Not set</Text>;
  }

  return (
    <ChakraFlex
      {...(ariaLabelledBy ? { 'aria-labelledby': ariaLabelledBy } : {})}
      flexDirection="row"
      flexWrap="wrap"
      gap="6px"
      id={tagListId}
    >
      {tags.map((tag, index) => {
        const tagListItemId = `${tagListId}__item-${index}`;
        return (
          <Tag
            color={TagColor.transparent}
            id={tagListItemId}
            isBorderRequired
            key={tagListItemId}
            value={tag}
          />
        );
      })}
    </ChakraFlex>
  );
};

export default TagListOrNotSet;
